import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../models/result.model';
import {
  ComposerOfferOrOrder, CustomAddress,
  IActionResponse,
  IBrokeringTargetsResponse,
  IActionStudioSearchResult,
  IActionTypes,
  IFrowardUsers,
  IGetAppointments, LeadAction, NotInterestedDetail, NotInterestedTypes,
  PlaceInOrder
} from '../../models/action.model';
import { IFileDocument } from '../../models/shared.model';
import { AppointmentExtProp, OfferExtProp, OrderExtProp, SelectedComposerOffers } from "../../models/leads/leads.model";

export const ACTION_DATA_SERVICE = new InjectionToken('[ActionDataService]');

export interface ActionDataService {

  getRejectTypes(): ObservableResult<IActionTypes[]>;

  getNotInterestedTypes(leadTypeId?: number): ObservableResult<NotInterestedTypes[] | IActionTypes[]>;

  getNotInterestedDetails(): ObservableResult<NotInterestedDetail[]>;

  getAppointmentTypes(): ObservableResult<IActionTypes[]>;

  getForwardUsers( leadId: number, leadTypeId: number ): ObservableResult<IFrowardUsers>;

  forwardRequest( leadId: number, comment: string, forwardUserId: number, forwardLeadTypeId: number, externalEmail: string ): ObservableResult<IActionResponse>;

  rejectRequest( leadId: number, comment: string, rejectReasonId: number ): ObservableResult<IActionResponse>;

  confirmRequest( leadId: number ): ObservableResult<IActionResponse>;

  completeRequest( leadId: number, comment: string, isExternal?: boolean ): ObservableResult<IActionResponse>;

  closeRequest( leadId: number, comment: string, notInterestedTypeId: number, notInterestedDetailId?: number ): ObservableResult<IActionResponse>;

  submitOffer( leadId: number,
               comment: string,
               appointmentTypeId: number,
               appointmentDate: Date,
               extendedProperties: OfferExtProp[] | OfferExtProp | SelectedComposerOffers,
               isComposerOffer: boolean,
               showroomTypeId?: string,
               isExternal?: boolean
  ): ObservableResult<IActionResponse>;

  submitComposerOfferOrder( leadId: number, data: ComposerOfferOrOrder ): ObservableResult<IActionResponse>;

  deleteComposerOfferOrder( leadId: number, offerId: number ): ObservableResult<IActionResponse>;

  composerOfferSetToMain( leadId: number, offerId: number ): ObservableResult<IActionResponse>;

  composerMultiOffersSetToMain( leadId: number, offerIds: number[] ): ObservableResult<IActionResponse>;

  undoAssignment( leadId: number, comment: string ): ObservableResult<IActionResponse>;

  reopenLead( leadId: number, comment: string ): ObservableResult<IActionResponse>;

  placeOrder( leadId: number, placeInOrder: PlaceInOrder, isExternal?: boolean ): ObservableResult<IActionResponse>;

  changeType( leadId: number, comment: string, leadTypeId: number ): ObservableResult<IActionResponse>;

  changeSource( leadId: number, leadSourceId: number ): ObservableResult<IActionResponse>;

  createAppointment(
    leadId: number,
    comment: string,
    appointmentTypeId: number,
    appointmentDate: Date,
    extendedProperties: AppointmentExtProp,
    showroomTypeId?: string,
    isExternal?: boolean
  ): ObservableResult<IActionResponse>;

  createConsultation(
    leadId: number,
    comment: string,
    appointmentTypeId: number,
    appointmentDate: Date,
    extendedProperties: AppointmentExtProp,
    showroomTypeId?: string,
    isExternal?: boolean
  ): ObservableResult<IActionResponse>;


  moveAppointment( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse>;

  moveOffer( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse>;

  visitPlanner( leadId: number, comment: string, appointmentDate: Date, appointmentTypeId: number, isPlanerVisitMove: boolean, isExternal: boolean, address?: CustomAddress ): ObservableResult<IActionResponse>;

  invitePlanner( leadId: number, comment: string, appointmentDate: Date, kkz: string, appointmentTypeId: number, isPlanerInviteMove: boolean, isExternal: boolean ): ObservableResult<IActionResponse>;

  compendiumAllow( leadId: number, comment: string ): ObservableResult<IActionResponse>;

  compendiumDeny( leadId: number, comment: string ): ObservableResult<IActionResponse>;

  leadBrokerAbort( leadId: number, comment: string ): ObservableResult<IActionResponse>;

  sendReminder( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse>;

  sendExternalEmail( leadId: number, externalEmail: string ): ObservableResult<IActionResponse>;

  createComment( leadId: number, comment: string, attachments?: IFileDocument[] ): ObservableResult<IActionResponse>;

  delayOffer( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse>;

  sendEmail( leadId: number, comment: string, externalEmail: string ): ObservableResult<IActionResponse>;

  getSnippets(): ObservableResult<LeadAction[]>;

  sendKkz( leadId: number, comment: string, kkz: string, externalEmail: string ): ObservableResult<IActionResponse>;

  updateIsSharedStatus( leadId: number, isShared: boolean ): ObservableResult<IActionResponse>;

  getAppointments( userId: number ): ObservableResult<IGetAppointments>;

  createNegotiation(
    leadId: number,
    comment: string,
    appointmentTypeId: number,
    appointmentDate: Date,
    showroomTypeId?: string,
  ): ObservableResult<IActionResponse>;

  moveNegotiation( leadId: number, comment: string, appointmentDate: Date ): ObservableResult<IActionResponse>;

  leadTakeover( leadId: number, comment: string ): ObservableResult<IActionResponse>;

  studioSearch( searchText ): ObservableResult<IActionStudioSearchResult[]>;

  getBrokeringTargets( leadId: number ): ObservableResult<IBrokeringTargetsResponse>;

  startBrokering( leadId: number, maxAcceptedPartners: number, secondWaveDetailMinutes: number ): ObservableResult<IActionResponse>;
}
